import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { cn } from './cn';

const ActionTarget = createContext<HTMLElement | null | undefined>(undefined);
/** Commandes de lot dans l'ordre du parcours ; les revues restent sous la barre. */
export function StudioActionBar({ children, label, className, panels = false }: { children: ReactNode; label: string; className?: string; panels?: boolean }) {
  const [target, setTarget] = useState<HTMLDivElement | null>(null);
  const layout = 'flex flex-col items-start gap-2 sm:flex-row sm:flex-wrap sm:items-center';
  if (!panels) return <div role="group" aria-label={label} data-studio-action-bar className={cn(layout, className)}>{children}</div>;
  return <ActionTarget.Provider value={target}>
    <div className={cn('flex min-w-0 flex-col gap-3', className)}>
      <div ref={setTarget} role="group" aria-label={label} data-studio-action-bar className={layout} />
      {children}
    </div>
  </ActionTarget.Provider>;
}
/** Un déclencheur peut appartenir à un composant avec une revue, sans étirer son bouton. */
export function StudioAction({ children }: { children: ReactNode }) {
  const target = useContext(ActionTarget);
  return target === undefined ? <>{children}</> : target ? createPortal(children, target) : null;
}
